(function () {
    if(!window.jstransobj) {
        window.jstransobj = { linkPrefix : "" };
    }

    fetch(window.jstransobj.linkPrefix + '/redtrack-init?' + location.search.slice(1), { credentials: 'include' })
    .then(function (r) { return r.json(); })
    .catch(function (error) {
        console.error('Error fetching RTK data:', error);
    });
})();